import { render, staticRenderFns } from "./modularChild3.vue?vue&type=template&id=663286db&scoped=true"
import script from "./modularChild3.vue?vue&type=script&lang=js"
export * from "./modularChild3.vue?vue&type=script&lang=js"
import style0 from "./modularChild3.vue?vue&type=style&index=0&id=663286db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663286db",
  null
  
)

export default component.exports